import React, { useState, useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Link } from "../components/L";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import useSEO from "../hooks/useSEO";
import { formatPrice } from "../utils/price";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentSuccess = () => {
  const { tx } = useLanguage();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking");
  const [txn, setTx] = useState(null);

  useSEO({
    title: tx("Pagesa u Krye me Sukses"),
    description: tx("Faleminderit per pagesen. Regjistrimi juaj u konfirmua me sukses."),
  });

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/checkout/status/${sessionId}`);
        setTx(res.data);
        if (res.data.payment_status === "paid") { setStatus("success"); return; }
        if (res.data.status === "expired") { setStatus("expired"); return; }
        attempts++;
        if (attempts < 6) setTimeout(poll, 2500);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "linear-gradient(180deg, #F8FFFE 0%, #EDF7F8 100%)" }} data-testid="payment-success-page">
      <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-10 max-w-lg w-full text-center">
        {status === "checking" && (
          <>
            <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center bg-[#E6F7F8] animate-pulse">
              <i className="fas fa-spinner fa-spin text-2xl text-[#1CA3B0]"></i>
            </div>
            <h2 className="text-xl font-bold mb-2" style={{ fontFamily: "'Noto Sans', sans-serif" }}>{tx("Duke verifikuar pagesen...")}</h2>
            <p className="text-sm text-[#828D9E]">{tx("Ju lutem prisni disa sekonda.")}</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: "linear-gradient(130deg, #3CD4E1 0%, #003F72 100%)" }}>
              <i className="fas fa-check text-3xl text-white"></i>
            </div>
            <h2 className="text-2xl font-bold mb-3" style={{ color: "#08707A", fontFamily: "'Noto Sans', sans-serif" }}>{tx("Pagesa u krye me sukses!")}</h2>
            <p className="text-[#4A5568] mb-2">{tx("Regjistrimi per eventin")} <strong>"{txn?.event_title}"</strong> {tx("u konfirmua.")}</p>
            <p className="text-sm text-[#828D9E] mb-8">{tx("Do t'ju kontaktojme se shpejti me te gjitha detajet.")}</p>
            {txn && (
              <div className="bg-slate-50 rounded-xl p-4 text-sm text-left mb-6 space-y-1">
                <p><strong>{tx("Event:")}</strong> {txn.event_title}</p>
                <p><strong>{tx("Shuma:")}</strong> {formatPrice(txn.amount)}</p>
                <p><strong>{tx("Statusi:")}</strong> <span className="text-green-600 font-semibold">{tx("Paguar")}</span></p>
              </div>
            )}
            <Link to="/evente" className="rounded-lg px-8 py-3 font-semibold text-sm text-white inline-flex items-center gap-2" style={{ background: "linear-gradient(130deg, #3CD4E1 0%, #003F72 100%)" }} data-testid="back-to-events">
              <i className="fas fa-arrow-left"></i> {tx("Kthehu tek Eventet")}
            </Link>
          </>
        )}
        {status === "pending" && (
          <>
            <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center bg-amber-50">
              <i className="fas fa-clock text-2xl text-amber-500"></i>
            </div>
            <h2 className="text-xl font-bold mb-2">{tx("Pagesa ne pritje")}</h2>
            <p className="text-sm text-[#828D9E] mb-6">{tx("Pagesa juaj eshte duke u procesuar. Do t'ju njoftojme me email kur te konfirmohet.")}</p>
            <Link to="/evente" className="text-[#1CA3B0] font-semibold text-sm hover:underline">{tx("Kthehu tek Eventet")}</Link>
          </>
        )}
        {(status === "error" || status === "expired") && (
          <>
            <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center bg-red-50">
              <i className="fas fa-times text-2xl text-red-500"></i>
            </div>
            <h2 className="text-xl font-bold mb-2">{status === "expired" ? tx("Sesioni ka skaduar") : tx("Ndodhi nje gabim")}</h2>
            <p className="text-sm text-[#828D9E] mb-6">{tx("Ju lutem provoni perseri ose na kontaktoni per ndihme.")}</p>
            <Link to="/evente" className="text-[#1CA3B0] font-semibold text-sm hover:underline">{tx("Kthehu tek Eventet")}</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
